// One switch for debug console traces: localStorage.cheddarDebug = '1'.
// Re-read at most once a second, so the off path is a Date.now() compare.
let _on = false, _chk = 0
export function dbgOn() {
  const now = Date.now()
  if (now - _chk > 1000) {
    _chk = now
    try { _on = typeof localStorage !== 'undefined' && localStorage.getItem('cheddarDebug') === '1' } catch { _on = false }
  }
  return _on
}
